module.exports = __webpack_public_path__ + "img/NetNote-Blanc.9c9520f5.png";